export default __webpack_public_path__ + "static/media/win.8c56e089.mp3";